import React, { useState } from 'react'
import Sidebar from './Sidebar'
import { SidebarProvider } from './SidebarContext'

export default function SidebarLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev)
  const closeSidebar = () => setIsSidebarOpen(false)

  return (
    <SidebarProvider value={{ isSidebarOpen, toggleSidebar, closeSidebar }}>
      <section className={`dashboard-main-sec ${isSidebarOpen ? "sidebar-open" : ""}`}>
        <div
          className={`sidebar-overlay ${isSidebarOpen ? "show" : ""}`}
          onClick={closeSidebar}
          aria-hidden="true"
        ></div>
        <div className='main-container'>
            <Sidebar/>
           {props.children}
        </div>
      </section>
    </SidebarProvider>
  )
}
